import { render, staticRenderFns } from "./DashRankList.vue?vue&type=template&id=4311ccbf&scoped=true"
import script from "./DashRankList.vue?vue&type=script&lang=js"
export * from "./DashRankList.vue?vue&type=script&lang=js"
import style0 from "./DashRankList.vue?vue&type=style&index=0&id=4311ccbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4311ccbf",
  null
  
)

export default component.exports